/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileContactInfo_tradeFirm = {
    readonly serviceId: string | null;
    readonly name: string | null;
    readonly publicProfile: {
        readonly profilePhoto: string | null;
        readonly urlLabel: string | null;
        readonly email: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ContactDesignerModal_tradeFirm">;
    readonly " $refType": "ProfileContactInfo_tradeFirm";
};
export type ProfileContactInfo_tradeFirm$data = ProfileContactInfo_tradeFirm;
export type ProfileContactInfo_tradeFirm$key = {
    readonly " $data"?: ProfileContactInfo_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileContactInfo_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProfileContactInfo_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "profilePhoto",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ContactDesignerModal_tradeFirm",
      "args": null
    }
  ]
};
(node as any).hash = 'f4c78192890bafe7a932a042cb611f65';
export default node;
